import { render, staticRenderFns } from "./MedicalClassSelector.vue?vue&type=template&id=3ab1879c&scoped=true&"
import script from "./MedicalClassSelector.vue?vue&type=script&lang=js&"
export * from "./MedicalClassSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab1879c",
  null
  
)

export default component.exports